import { useState, useEffect, useCallback } from 'react';
import { Route, Switch } from 'react-router-dom';
import styled, { css } from 'styled-components';
import Drawer from 'components/Drawer';
import Feed from 'containers/Feed';
import IcNotification from 'components/icons/Notification';
import { getSelectedPlace } from 'selectors';
import { viewportSizes } from 'ui/utils';
import { useSelector } from 'react-redux';
import { size, ButtonReset } from 'ui';
import { get } from 'lodash';
import { useWindowSize } from 'react-use';

const FeedWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  padding: 16px;
`;

const NotificationContainer = styled.div`
  position: relative;

  ${ButtonReset} {
    color: white;
  }
  cursor: pointer;
`;

const NotificationBadge = styled.span`
  position: absolute;
  background-color: ${({ theme }) => theme.error};
  color: #fff;
  width: 1.5em;
  height: 1.5em;
  font-size: ${size(-3)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  right: 0;
  top: 0;
  transform: translate3d(50%, -50%, 0);

  ${props =>
    props.size === 'medium' &&
    css`
      width: 1.75em;
      height: 1.75em;
    `} ${props =>
    props.size === 'big' &&
    css`
      width: 2em;
      height: 2em;
    `};
`;

const MobileNotification = () => {
  const [isOpen, setIsOpen] = useState(false);
  const place = useSelector(state => getSelectedPlace(state));
  const { location } = useSelector(state => state.router);
  const { width } = useWindowSize();
  const toggleDrawer = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const highlightNotif = get(location, 'state.highlightedWorkOrder');

  useEffect(() => {
    if (!isOpen && highlightNotif && width <= viewportSizes.tablet) {
      toggleDrawer();
    }
  }, [highlightNotif, isOpen, toggleDrawer, width]);

  return (
    <FeedWrapper>
      <NotificationContainer>
        <ButtonReset onClick={() => toggleDrawer()}>
          <IcNotification size={24} />
        </ButtonReset>
        {Boolean(place.unreadFeedEventCount) && (
          <NotificationBadge
            size={
              place.unreadFeedEventCount > 99
                ? 'big'
                : place.unreadFeedEventCount > 9
                ? 'medium'
                : null
            }
          >
            {place.unreadFeedEventCount}
          </NotificationBadge>
        )}
      </NotificationContainer>

      {isOpen && (
        <Drawer onRequestClose={toggleDrawer} title="Notifications">
          <Switch>
            <Route component={Feed} />
          </Switch>
        </Drawer>
      )}
    </FeedWrapper>
  );
};

export default MobileNotification;
